import { render, staticRenderFns } from "./storeProductCom.vue?vue&type=template&id=bd1c71be"
import script from "./storeProductCom.vue?vue&type=script&lang=js"
export * from "./storeProductCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports